VjsAdmin.LicenseGroups = (function () {
    const selections = [];
    const me = {};
    me.bulk_delete_max = 400;
    me.$groups_table = $('#groups-table');
    me.platform_id = me.$groups_table.attr('data-platform-id');
    me.district_joint_guid = me.$groups_table.attr('data-district-joint-guid');
    me.license_id = me.$groups_table.attr('data-license-id');

    me.init = function () {
        me.initTable();
    };

    me.initTable = function () {
        me.$groups_table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#groups-table',
            formatNoMatches() {
                return 'No groups in this license!';
            },
            showColumns: true,
            buttonsAlign: 'right',
            idField: 'group_id',
            toolbar: '#report-toolbar',
            sortName: 'group_id',
            clickToSelect: true,
            url: Slim.Router.pathFor('platforms.districts.licenses.groups.list.json', {
                platform_id: me.platform_id,
                district_joint_guid: me.district_joint_guid,
                license_id: me.license_id,
            }),
            columns: [
                {
                    field: 'checkbox',
                    title: 'Delete',
                    checkbox: true,
                    visible: false,
                },
                {
                    title: 'Name',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Owner',
                    field: 'owner',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Shared?',
                    field: 'shared',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Bulk Uploaded?',
                    field: 'bulk_upload_id',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Rostering Type',
                    field: 'rostering_type',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    visible: false,
                },
                {
                    title: 'Rostering ID',
                    field: 'rostering_id',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    visible: false,
                },
                {
                    title: '# Users',
                    field: 'number_of_users',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                    field: 'date_created',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the groups timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    row.checkbox = $.inArray(row.group_id, selections) !== -1;

                    row.is_active = row.active;

                    if (+row.active === 0) {
                        row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    if (+row.shared === 1) {
                        row.shared = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    } else {
                        row.shared = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    }

                    if (row.bulk_upload_id >= 1) {
                        row.bulk_upload_id = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    } else {
                        row.bulk_upload_id = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.groups.view')) {
                        const groupUrl = Slim.Router.pathFor('platforms.districts.groups.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            group_id: row.group_id,
                        });
                        row.name = `<a href="${groupUrl}">${row.name}</a>`;
                    }

                    if (row.owner_id && VjsAdmin.hasPermission('platforms.districts.licenses.users.view')) {
                        const ownerUrl = Slim.Router.pathFor('platforms.districts.licenses.users.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            license_id: me.license_id,
                            user_id: row.owner_id,
                        });
                        row.owner = `<a href="${ownerUrl}">${row.owner_first_name} ${row.owner_last_name}</a>`;
                    }
                });
                return formattedResult;
            },
        });
    };

    return {
        init: me.init,
    };
}());
